module.exports = __webpack_public_path__ + "img/ford-logo.a0deb9d8.png";